import React from 'react';
import { useTranslation } from 'react-i18next';
import SvgFavorite from '../../../../../play-core/icons/Favorite';
import SvgFavoriteOutline from '../../../../../play-core/icons/FavoriteOutline';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useDataDispatch, useShowState } from '../../../providers/DataProvider/DataContext';
import { ActionTitle } from '../../Topic/ActionTitle';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShowTitle = ({
  show
}) => {
  const {
    t
  } = useTranslation();
  const {
    favoriteShowIds
  } = useShowState();
  const dispatch = useDataDispatch();
  const {
    favoritesSupported
  } = useVideoConfig();
  return /*#__PURE__*/_jsx(ActionTitle, {
    title: show.title,
    onAction: () => dispatch({
      type: 'toggle-show-favorite',
      showId: show.id,
      showTitle: show.title,
      showSnackbar: true
    }),
    ariaIconTitle: `${show.title} ${t('global.favor')}`,
    activeIcon: /*#__PURE__*/_jsx(SvgFavorite, {}),
    inactiveIcon: /*#__PURE__*/_jsx(SvgFavoriteOutline, {}),
    isActive: favoriteShowIds.includes(show.id),
    showAction: favoritesSupported
  });
};